import Head from "next/head";
import {useUrl} from 'nextjs-current-url';

const PageHead = ({title}) => {
    const {href: currentUrl} = useUrl() ?? {};
    const titleMsg = `${title} | ${process.env.NEXT_PUBLIC_SITE_TITLE}`;
    return (
        <Head>
            <title>{titleMsg}</title>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            <link rel="icon" href="/favicon.ico"/>
            <link rel="canonical" href={currentUrl}/>
        </Head>
    );
};

export default PageHead;